/*
 * Modal is a fullscreen overlay that darkens the page behind the content and provides a close button in the top-right of the viewport
 *
 * Used by:
 *     - Homepage (Video gallery)
 *     - Product Detail page (main image zoom, details & finishes popups, howto)
 *     - DYO (main image zoom, howto)
 *     - BYO (tab 3 video)
 */

'use strict';

var React = require('react');

var Constants = require('../../constants');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./modal.scss');
}

module.exports = React.createClass({
    propTypes: {
        // Dimensions of interior content (for centering?) (defaults to 1000x600 ?)
        width: React.PropTypes.number,
        height: React.PropTypes.number,

        // When closed, render a label that when clicked on, opens the modal
        label: React.PropTypes.node,

        // Start with the Modal open? (default false)
        startOpen: React.PropTypes.bool,

        // Show the close icon in the top-right? (default true)
        showClose: React.PropTypes.bool,

        // Callback to call when the modal is closed
        onClose: React.PropTypes.func,
    },
    getInitialState: function() {
        return {
            open: this.props.startOpen ? this.props.startOpen : false,
        };
    },
    // open: function() {
    //     if (this.props.onOpen)
    //     {
    //         this.props.onOpen();
    //     }
    //     $('html,body').css('overflow', 'hidden');
    // },
    open: function() {
        this.setState({
            open: true
        });
    },
    close: function() {
        this.setState({
            open: false
        });
        // $('html,body').css('overflow', 'inherit');
        if (this.props.onClose)
        {
            this.props.onClose();
        }
    },
    // componentDidMount: function() {
    //     $('html,body').css('overflow', 'inherit');
    //     this.open();
    // },
    render: function() {
        var boxStyle = {};
        if (this.props.width !== undefined && this.props.height !== undefined)
        {
            boxStyle = {
                width: this.props.width,      /// !!!!
                height: this.props.height
            }
        }
        var label = null;
        if (this.props.label) {
            label = (
                <div onClick={this.open} className='sp-modal-label'>
                    {this.props.label}
                </div>
            );
        }
        if (this.props.label && !this.state.open) {
            return label;
        }
        if (!this.state.open) {
            return null;
        }
        var showClose = this.props.showClose == undefined || this.props.showClose != false;  // defaults to true
        return (
            <div className='sp-modal' style={boxStyle}>
                <div className='sp-modal-overlay' onClick={this.close} />
                {showClose ?
                    <a className='sp-modal-close' onClick={this.close}>
                        <img src={Constants.static + 'images/global/close/close-grey2.png'} className='hd-menubar-close' />
                    </a>
                : null}
                <div className='sp-modal-box' style={boxStyle}>
                    {this.props.children}
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/plugins/modal/modal.jsx